
<main>
    <div class="memberList">
        <a routerLink="/city/district-list" class="list-item">
            <h4>જિલ્લાની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a>
    </div>
</main>